import React, { useMemo } from 'react';
import MultiSelect from 'components/atoms/multiSelect/MultiSelect';
import { TimeColumnParam } from 'constants/params/paramKeys';
import useCustomSearchParams from 'hooks/searchParams/useCustomSearchParams';

export function TimeColumnPicker({ options, defaultColumn }) {
  const { searchParams, updateSearchParams, deleteSearchParams } = useCustomSearchParams();

  const setSelectedTimeColumn = (option) => {
    if (option.id === defaultColumn.id) {
      deleteSearchParams([TimeColumnParam]);
    } else {
      updateSearchParams({ [TimeColumnParam]: option.id });
    }
  };

  const selectedTimeColumn = useMemo(() => {
    const timeColumnParam = searchParams.get(TimeColumnParam);

    return timeColumnParam ? Object.values(options).find((o) => o.id === timeColumnParam) : defaultColumn;
  }, [options, defaultColumn, searchParams]);

  return (
    <MultiSelect
      testId='time-column-picker'
      isMulti={false}
      labelClassName='font-medium'
      isClearable={false}
      isSearchable={false}
      selectedOptions={selectedTimeColumn}
      setSelectedOptions={setSelectedTimeColumn}
      options={options}
      sortOptions={false}
      className={'lg:w-[180px]'}
    />
  );
}
